module.exports = __webpack_public_path__ + "static/media/Screenshot1.250ca80a.png";